import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import { createLogger } from 'redux-logger' // eslint-disable-line import/no-extraneous-dependencies
import thunk from 'redux-thunk'
import * as reducer from './reducer/index'

import TokenStorage from './redux-citation-api/tokenStorage'
import api from './api'
import gapi from './gapi'
import config from './config'

export const prepareMiddleWare = ({ wptAppUrl, wptApiUrl, onUploadSuccess, cfeAuth, cfeApiUrl, onCfeAuthUpdate }) => {
  const tokenStorage = new TokenStorage()
  config.setTokenStorage(tokenStorage)
  config.setWptAppUrl(wptAppUrl)
  config.setOnUploadSuccess(onUploadSuccess)
  if (cfeAuth) {
    config.setcfeAuth()
    config.setCfeApiUrl(cfeApiUrl)
    config.setOnCfeAuthUpdate(onCfeAuthUpdate)
  }

  api.setApiRoot(wptApiUrl)

  const enhancers = [
    thunk.withExtraArgument({
      api,
      gapi,
      config,
      tokenStorage,
    }),
  ]

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
    const logger = createLogger({ collapsed: true })
    enhancers.push(logger)
  }
  return enhancers
}

const configureStore = initialState => {
  const reducers = combineReducers(reducer)
  const {
    wptAppUrl,
    wptApiUrl,
    onUploadSuccess,
    cfeAuth,
    cfeApiUrl,
    onCfeAuthUpdate,
    ...reduxProperties
  } = initialState

  const globalWindow = typeof window !== 'undefined'
  if (!globalWindow) {
    return createStore(reducers, reduxProperties)
  }

  const middleWare = prepareMiddleWare({ wptApiUrl, wptAppUrl, onUploadSuccess, cfeAuth, cfeApiUrl, onCfeAuthUpdate })
  let composeEnhancers = compose

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-underscore-dangle
    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      // eslint-disable-next-line no-underscore-dangle
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    }
  }
  return createStore(reducers, reduxProperties, composeEnhancers(applyMiddleware(...middleWare)))
}

export default configureStore
